import { FC } from 'react';
import ZendeskFAQsContainer from 'components/activity/help/zendeskFAQs/containers/ZendeskFAQsContainer';

const Help: FC = () => {
    return <ZendeskFAQsContainer />;
};

export default Help;
